module.exports = __webpack_public_path__ + "img/sfondo_login.6b31c809.png";